import { LocationVarInheritance, LocationScope } from "@swivl-mono/types";
import "./InheritancePill.scss";

interface Props {
	inheritance: LocationVarInheritance;
	isEditing: boolean;
	canRevert: boolean;
	onClick: () => void;
	alwaysShow?: boolean;
	customText?: {
		customEditing?: string;
		custom?: string;
		fromOrg?: string;
		fromGroup?: string;
		default?: string;
	}
}

export function InheritancePill(props: Props) {
	const { inheritance, customText, isEditing, canRevert } = props;
	const alwaysShowClass = props.alwaysShow ? "alwaysShow" : "";

	if (inheritance === LocationVarInheritance.NONE) {
		if (isEditing && canRevert) {
			return <div className={`InheritancePill isEditing custom ${alwaysShowClass} group-hover:opacity-100`} onClick={props.onClick}>
				<p className="normalText">{customText?.customEditing || "Custom"}</p><p className="hoverText">Revert</p>
			</div>
		}


		return (
			<div className={`InheritancePill custom ${alwaysShowClass} group-hover:opacity-100`}>
				<p>{customText?.custom || "Custom"}</p>
			</div>
		)
	}
	if (inheritance === LocationVarInheritance.ORG) {
		return (
			<div className={`InheritancePill org ${alwaysShowClass} group-hover:opacity-100`}>
				<p>{customText?.fromOrg || "From Org"}</p>
			</div>
		)
	}
	if (inheritance === LocationVarInheritance.GROUP) {
		return (
			<div className={`InheritancePill group ${alwaysShowClass} group-hover:opacity-100`}>
				<p>{customText?.fromGroup || "From Group"}</p>
			</div>
		)
	}
	if (inheritance === LocationVarInheritance.DEFAULT) {
		return (
			<div className={`InheritancePill default ${alwaysShowClass} group-hover:opacity-100`}>
				<p>{customText?.default || "Default"}</p>
			</div>
		)
	}

}